import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { LAYOUT, MIN_WIDTH } from '../Layout/enums';

import './styles.css';

const getComponent = layout => ({
  listLabel,
  filters = [],
  children,
  hideBorder,
}) => {
  let styleSuff = '';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      break;
    // no default
  }
  return (
    <div styleName={`flexMain${styleSuff}`}>
      {layout === LAYOUT.DESK ?
        <div styleName="listCol">
          <div styleName={`listLabel ${hideBorder ? 'listLabelNoBorder' : ''}`}>{listLabel}</div>
          {children}
        </div>
        : null}
      <div styleName={`filterCol${styleSuff}`}>
        {filters.map((filter) => {
          const { Comp, props } = filter;
          return (<Comp key={uniqueId()} {...props} />);
          })}
      </div>
      {layout !== LAYOUT.DESK ?
        <div styleName={`listCol${styleSuff}`}>
          <div styleName={`listLabel${styleSuff} ${hideBorder ? 'listLabelNoBorder' : ''}`}>{listLabel}</div>
          {children}
        </div>
        : null}
    </div>
  );
};

export const Desktop = getComponent(LAYOUT.DESK);

export const Tablet = getComponent(LAYOUT.TAB);

export const Mobile = getComponent(LAYOUT.MOB);

const BaseFilteredList = ({
  listLabel,
  filters,
  children,
  mediaQueryValues,
  hideBorder,
}) => {
  const propsToPassToChild = {
    listLabel,
    filters,
    children,
    hideBorder,
  };
  return (
    <div>
      <MediaQuery
        minWidth={MIN_WIDTH.DESK}
        values={mediaQueryValues}
      >
        <Desktop
          {...propsToPassToChild}
        />
      </MediaQuery>
      <MediaQuery
        minWidth={MIN_WIDTH.TAB}
        maxWidth={MIN_WIDTH.DESK - 1}
        values={mediaQueryValues}
      >
        <Tablet
          {...propsToPassToChild}
        />
      </MediaQuery>
      <MediaQuery
        maxWidth={MIN_WIDTH.TAB - 1}
        values={mediaQueryValues}
      >
        <Mobile
          {...propsToPassToChild}
        />
      </MediaQuery>
    </div>
  );
};

BaseFilteredList.propTypes = {
  listLabel: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape({
    comp: PropTypes.element,
    props: PropTypes.shape({
      onChange: PropTypes.func,
      options: PropTypes.array,
    }),
  })),
  mediaQueryValues: PropTypes.shape({}),
};

BaseFilteredList.defaultProps = {
  listLabel: '',
  filters: [],
  mediaQueryValues: {},
};

export default BaseFilteredList;



// WEBPACK FOOTER //
// ./src/components/BaseFilteredList/index.js